import { BvQuickDial } from '@bv/components';

import ConnectivityStatus from '@/components/SharedComponents/Buttons/ConnectivityStatus.vue';
import { userDetailsStore } from '@/stores/auth/user-details.store';

// import profile_routes from './user-profile/user-profile.routes.js'
// TODO: FF: Dialer
// import dialerRoutes from './dialer/dialer.routes.js'
import aiRoutes from './ai';
import call_center_routes from './call-center/call-center.routes.js';
import callEvaluationRoutes from './call-evaluations/call-evaluations.routes.js';
import campaignRoutes from './campaign/campaign.routes';
import dashboard_routes from './dashboard/dashboard.routes.js';
import no_access_routes from './dashboard/no-access.routes.js';
import reports_routes from './reports/reports.routes.js';
import settingsRoutes from './settings/settings.routes.js';
const default_route = { path: '/', redirect: '/dashboard' };

const systemRoutes = {
  path: '/',
  name: 'main',
  component: () => import('@/views/SystemView.vue'),
  redirect: '/dashboard',
  meta: {
    prependHeaderActions: [BvQuickDial, ConnectivityStatus],
    headerActions: [
      { type: 'small', component: BvQuickDial },
      { type: 'small', component: ConnectivityStatus },
    ],
  },
  beforeEnter: async (to, from, next) => {
    const store = userDetailsStore();
    if (!store.getUserRoles) {
      await store.getUserDataRequest();
      await store.getUserRolesRequest();
    }
    if (!store.isActiveBilling && to.name !== 'no-access') {
      next({ name: 'no-access' });
    } else {
      next();
    }
  },
  children: [
    default_route,
    no_access_routes,
    dashboard_routes,
    settingsRoutes,
    call_center_routes,
    reports_routes,
    // profile_routes,
    // TODO: FF: Dialer
    // dialerRoutes,
    campaignRoutes,
    aiRoutes,
    callEvaluationRoutes,
  ],
};
export default systemRoutes;
